import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { DELETE_SPECIAL_CONSIDERATION_SUBJECT } from '../../constants/apiUrls';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

interface DeleteRequest {
  requestUuid: string;
  detailUuid: string;
}

export const useDeleteSpecialConsiderationSubject = ({ onSuccess, onError }: Input = {}) => {
  const deleteSpecialConsiderationSubject = async ({ requestUuid, detailUuid }: DeleteRequest) => {
    await axiosClient.delete(DELETE_SPECIAL_CONSIDERATION_SUBJECT(requestUuid, detailUuid));
  };
  return useCustomMutation(deleteSpecialConsiderationSubject, {
    onSuccess,
    onError,
  });
};
